import { ContainerTheme } from 'src/components/container/container-theme';

export const defaultContainerStyles: ContainerTheme = {
  maxWidth: '792px',
};
